export * from "-!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/framevuerk-builder/node_modules/pug-html-loader/lib/index.js!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/index.js??vue-loader-options!./fvHeader.vue?vue&type=template&id=09a0cf7c&lang=pug&"


//////////////////
// WEBPACK FOOTER
// ./src/components/fvHeader.vue?vue&type=template&id=09a0cf7c&lang=pug&
// module id = 90
// module chunks = 0 1